import { View } from 'backbone.marionette';
import template from './index.jst';
import Radio from 'backbone.radio';
import { Model } from 'backbone';

const matchUpChannel = Radio.channel('match_up');

export class MatchUpUsers extends View {
	get template() {
		return template;
	}

	get className() {
		return 'matchup-users';
	}

	initialize() {
		this.model = new Model({
			home: {},
			away: {}
		});

		this.listenTo(matchUpChannel, 'data:requested', this.onDataRequested);
	}

	onDataRequested({ matchup, is_match_active }) {

		this.model.set({
			...matchup.matchup_fixture,
			is_match_active
		});

		this.render();
	}
}

export default MatchUpUsers;